import PropTypes from 'prop-types'
import Select from '@mui/material/Select'
import './SortSelecter.css'

const SortSelecter = ({ children, className, label, name, onChange, value }) => {
    const classNames = `sort-selecter ${className ?? ''}`

    return (
        <div className={classNames}>
            <div className='label'>
                {label}
            </div>
            <Select
                className='value'
                name={name}
                value={value}
                variant='standard'
                onChange={onChange}
            >
                {children}
            </Select>
        </div>
    )
}

SortSelecter.propTypes = {
    className: PropTypes.string,
    //children: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
}

SortSelecter.defaultProps = {
    className: '',
    label: 'Sort By:',
    name: 'sort-by'
}

export default SortSelecter
